import { ComponentHealthCondition, HealthConditionColors } from 'features/fde'
import { NoRLHealthScore } from 'features/siteView/aggregateSiteData'
import { useGeckoTheme } from 'styles/GeckoTheme'
import {
  generateCheckerboardColorCSS,
  generateStripedColorCSS,
  updateColorOpacity,
} from 'utils/colorHelpers'

export function useSiteViewColors() {
  const { theme } = useGeckoTheme()

  return {
    [ComponentHealthCondition.Excellent]:
      getBreakdownDisplayBackgroundColorWithOpacity(
        HealthConditionColors[ComponentHealthCondition.Excellent]
      ),
    [ComponentHealthCondition.Fair]:
      getBreakdownDisplayBackgroundColorWithOpacity(
        HealthConditionColors[ComponentHealthCondition.Fair]
      ),
    [ComponentHealthCondition.Bad]:
      getBreakdownDisplayBackgroundColorWithOpacity(
        HealthConditionColors[ComponentHealthCondition.Bad]
      ),
    [ComponentHealthCondition.VeryPoor]:
      getBreakdownDisplayBackgroundColorWithOpacity(
        HealthConditionColors[ComponentHealthCondition.VeryPoor]
      ),
    [NoRLHealthScore.NoInspection]:
      getBreakdownDisplayBackgroundColorWithOpacity(theme.forecast.background3),
    [NoRLHealthScore.NotEnoughData]:
      getBreakdownDisplayBackgroundColorWithOpacity(theme.forecast.background4),
    noUnitData: getBreakdownDisplayBackgroundColorWithOpacity(
      theme.forecast.background2
    ),
  }
}

// ----------------------------------------------------------------------------
export function getBreakdownDisplayBackgroundColorWithOpacity(color: string) {
  return updateColorOpacity(color, 0.9)
}

// ----------------------------------------------------------------------------
export const CardBorderRadius = '0.25rem'

// ----------------------------------------------------------------------------
/** Generates a striped color in a style usable in site-view */
export function generateSiteViewStripedColor(
  color: string,
  color2: string = 'transparent'
) {
  return generateStripedColorCSS(color2, color, '1px', '90deg')
}

/** Generates a checkerboard color in a style usable in site-view */
export function generateSiteViewCheckerboardColor(
  color: string,
  color2: string = 'transparent'
) {
  return generateCheckerboardColorCSS(color, color2, '4px')
}

export const AssetTrackerHiddenItemOpacity = 0.25
